import { useMemo } from 'react';

var idCounter = 0;
var useUniqueId = function () {
    var id = useMemo(function () { return idCounter++; }, []);
    return "".concat(id);
};

export { useUniqueId };
//# sourceMappingURL=useUniqueId.esm.js.map
